// import { store } from '../store'
import api from './api.js'

export class ContentLibrary
{
  static async Get (store, locale) {
    if (!store.state.contentLibrary) {
      try {
        const contents = await api.getContents(false, locale)
        store.commit('SET_CONTENT_LIBRARY', contents)
      } catch (error) {
        console.error('Failed to load content library:', error)
        // Set empty array to prevent repeated failed attempts
        store.commit('SET_CONTENT_LIBRARY', [])
        throw error
      }
    }
    return store.state.contentLibrary
  }

  static GetModuleInfo (store, moduleID) {
    const module = store.state.contentLibrary.find(m => m.id === moduleID)
    return module
  }

  static GetCheckpointValue (store, moduleID, checkpointID) {
    const module = store.state.contentLibrary.find(m => m.id === moduleID)
    if (!module) return null
    const checkpoint = module.topics.find(c => c.id === checkpointID)
    if (!checkpoint) return null
    return checkpoint.completion
  }

  static HasCheckpointInfo (store, moduleID) {
    const module = store.state.contentLibrary.find(m => m.id === moduleID)
    if (!module || module.topics.length === 0) return false
    return true
  }

  static GetDuration (store, moduleID, checkpointID = null) {
    const module = store.state.contentLibrary.find(m => m.id === moduleID)
    if (!module) return null
    if (!checkpointID) return module.duration
    const checkpoint = module.topics.find(c => c.id === checkpointID)
    if (!checkpoint) return null
    return checkpoint.duration
  }

  static NameOf (store, locale, moduleID) {
    if (!store.state.contentLibrary || !Array.isArray(store.state.contentLibrary)) {
      return moduleID
    }
    const module = store.state.contentLibrary.find(m => m.uid === moduleID)
    if (!module) return moduleID
    return module.locales?.[locale]?.title ?? module.locales?.en?.title ?? moduleID
  }

  static ContentType = Object.freeze({
    MODULE: 'module',
    EXERCISE: 'exercise',
    SIMULATOR: 'simulator',
    HIDDEN: 'hidden',
  });
}
